module.exports = __webpack_public_path__ + "static/media/logo-white.5821507e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.png
// module id = 100
// module chunks = 0